export const ds_StaffDirectoryBlock_Entry = `
    fragment ds_StaffDirectoryBlock_Entry on ds_StaffDirectoryBlock_Entry {
        id
        canonicalUid
        staffDirectory_ContainerWidth
        staffDirectory_TopSpacing
        staffDirectory_ColorTheme
        staffDirectory_ColorPalette
        staffDirectory_FullWidthBackground

        staffDirectory_Heading
        staffDirectory_BodyText
        staffDirectory_Integration {
            category
            integration
        }
    }
`